function Icon10() {
    return (
        <svg id="icon10" width="350" height="199" viewBox="0 0 350 199" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="62.5" cy="136.502" r="54" stroke="#1B1B1B" stroke-width="17"/>
            <circle cx="287.5" cy="136.502" r="54" stroke="#1B1B1B" stroke-width="17"/>
            <rect x="128.401" y="37.4746" width="17" height="127.043" rx="8.5" transform="rotate(38.682 128.401 37.4746)" fill="#1B1B1B"/>
            <rect x="105.504" y="16.7812" width="17" height="149.712" rx="8.5" transform="rotate(-27.5805 105.504 16.7812)" fill="#1B1B1B"/>
            <rect x="122" y="57.002" width="17" height="120" rx="8.5" transform="rotate(-90 122 57.002)" fill="#1B1B1B"/>
            <rect x="89" y="28.002" width="17" height="36" rx="8.5" transform="rotate(-90 89 28.002)" fill="#1B1B1B"/>
            <rect x="162" y="18.002" width="17" height="58" rx="8.5" transform="rotate(-90 162 18.002)" fill="#1B1B1B"/>
            <rect x="222.059" y="46.1914" width="17" height="120.286" rx="8.5" transform="rotate(-33.2426 222.059 46.1914)" fill="#1B1B1B"/>
            <rect x="202" y="3.98828" width="17" height="53.3842" rx="8.5" transform="rotate(-13.5637 202 3.98828)" fill="#1B1B1B"/>
        </svg>
    )
}

export default Icon10